import React from 'react';
import { ThreeDots } from 'react-loader-spinner';
import PropTypes from 'prop-types'; // Import PropTypes
import { makeStyles } from '@mui/styles';

export default function LoaderC({ back }) {
  const useStyles = makeStyles(() => ({
    loading__spinner__main: {
      height: back ? 'auto' : '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      opacity: '0.6',
    },
  }));
  const classes = useStyles();
  return (
    <div className={classes.loading__spinner__main}>
      <div className="spinner">
        <ThreeDots
          height="80"
          width="80"
          radius="9"
          color="#00AB55"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible
        />
      </div>
    </div>
  );
}
LoaderC.propTypes = {
  back: PropTypes.string.isRequired,
};
